import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import PublicImage from "@/models/PublicImage/PublicImage";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";
import WebsiteRoute from "@/models/WebsiteRoute/WebsiteRoute";

export default class PhotoButton extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/photo-button';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetPhotoButtons';

    static model_name = 'PhotoButton';

    /**
     * Relations used for normalization
     * @returns {{}}
     */

    static fields() {
		return {
			id: this.number(null).nullable(),
			title: this.attr(null),
			link_text: this.attr(null),
			link_url: this.attr(null),
			website_route_id: this.number(null).nullable(),
			public_image_id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			display_type: this.attr(null),
			description: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
            route: this.belongsTo(WebsiteRoute, 'website_route_id'),
            publicImage: this.belongsTo(PublicImage, 'public_image_id'),
		}
	}

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    PublicImage() {
        return this.getRelated('publicImage');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
